import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=cc574dfc&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=cc574dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc574dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc574dfc')) {
      api.createRecord('cc574dfc', component.options)
    } else {
      api.reload('cc574dfc', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=cc574dfc&scoped=true&", function () {
      api.rerender('cc574dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/onePageAdv/Edit.vue"
export default component.exports